import { Button, Dialog } from '@/components/DesignSystem';
import { IntegrationSyncType } from "@shared/enums";
import React from "react";
import { SyncHistoryTable } from "@/pages/Admin/HierarchyOfRetailers/Integrations/SyncHistoryTable";

interface SyncHistoryModalProps {
  onCancel: () => void,
  retailerId: string,
  selectedSyncType: IntegrationSyncType,
}

export const SyncHistoryModal = ({
  onCancel,
  retailerId,
  selectedSyncType,
}: SyncHistoryModalProps) => {
  return (
    <Dialog
      cancelButton={(props) => (
        <Button
          {...props}
          onClick={onCancel}
        >
          Close
        </Button>
      )}
      onClose={onCancel}
      open
      testID="sync-history-modal"
      title={`Sync history for ${selectedSyncType}`}
    >
      <SyncHistoryTable retailerId={retailerId} selectedSyncType={selectedSyncType} />
    </Dialog>
  );
};
